module.exports = function Worker_fn() {
  return new Worker(__webpack_public_path__ + "pdfExport.worker.js");
}
